<div class="bg-[#FAFAFA] w-full flex justify-center items-center">
  <div
    class="flex w-full max-w-[1200px] flex-col items-start pt-[48px] pb-[32px] gap-[16px] sm:pt-[60px] sm:pb-[120px] px-[24px]">
    <!-- Section Header -->
    <div class="flex flex-col items-start gap-4 self-stretch pb-[32px] sm:pb-[80px]">
      <span
        class="text-[#00B884] text-center font-[Manrope] text-[16px] font-medium leading-[17px] tracking-[1px] uppercase">
        {{ 'RECOMMENDED FOR YOU' | translate }}
      </span>
      <h2
        class="self-stretch font-[Manrope] text-[28px] sm:text-[45px] font-bold leading-[36px] sm:leading-[58px] tracking-[-0.9px]">
        {{ 'Product you may be interested' | translate }}
      </h2>
      <span class="w-[100px] h-[5px] rounded-[5px] bg-[#FD71AF] block"></span>
    </div>

    <!-- Cards Section -->
    <div class="flex w-full flex-col sm:flex-row items-start gap-[16px] sm:gap-[20px]">
      <div class="relative w-full overflow-hidden">
        <!-- ✅ Scrollable slider container -->
        <div #scrollContainer
          class="flex overflow-x-auto snap-x snap-mandatory scroll-smooth scrollbar-hide gap-[16px] sm:gap-[20px] px-4 sm:px-0 pr-[32px] pb-[10px]">
          <!-- ✅ Slides -->
          <div *ngFor="let item of insurances; let i = index"
            class="snap-start shrink-0 w-[90%] sm:w-[48%] md:w-[31%] lg:w-[31%] flex flex-col rounded-tl-[22px]">
            <!-- Image -->
            <div class="w-full aspect-[4/3] overflow-hidden rounded-tl-[22px]">
              <img [src]="item.img" [alt]="item.title" class="w-full h-full object-cover" />
            </div>

            <!-- Content -->
            <div class="flex flex-col flex-1 pt-4 justify-between">
              <div>
                <h3
                  class="text-[#1B1B1B] font-extrabold text-[18px] sm:text-[20px] leading-normal tracking-[-0.44px] font-[Manrope] mb-[10px]">
                  {{ item.title | translate }}
                </h3>
                <p
                  class="text-[#1B1B1B] mb-[16px] text-[14px] sm:text-[15px] font-normal leading-[150%] font-[Manrope] opacity-80">
                  {{ item.description | translate }}
                </p>
              </div>

              <a [href]="item.btnLink" target="_blank" rel="noopener noreferrer" class="flex px-5 py-3 justify-center items-center rounded-full border border-[#2AD189]
                       text-[#2AD189] font-medium bg-white transition-all duration-300
                       hover:shadow-[2px_4px_4px_#00000040] hover:border-[#2AD189]">
                {{ item.btnText | translate }}
              </a>
            </div>
          </div>
        </div>

        <!-- ✅ Pagination dots (centered on small screens) -->
        <div class="flex justify-center mt-4 sm:hidden">
          <div *ngFor="let item of insurances; let i = index" (click)="setActive(i)"
            class="w-3 h-3 mx-1 rounded-full cursor-pointer transition-all duration-300"
            [ngClass]="activeIndex === i ? 'bg-[#2AD189] scale-110' : 'bg-gray-300'"></div>
        </div>
      </div>
    </div>
  </div>
</div>